import { createFileRoute } from '@tanstack/react-router';
import DocsGroupHome from '@/components/Docs/DocsGroupHome';

export const Route = createFileRoute('/developers/v2/')({
  component: DevelopersV2HomePage,
});

function DevelopersV2HomePage() {
  return <DocsGroupHome group="developers" version="v2" />;
}
